import script from "./AverageSearchForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./AverageSearchForm.vue?vue&type=script&lang=ts&setup=true"

import "./AverageSearchForm.vue?vue&type=style&index=0&id=75bb0302&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75bb0302"]])

export default __exports__